module.exports = {"id":"176545","name":"Christian Marrugo","rating":"75","photo":"./data/images/photos/3/176545.png","club":{"name":"Puebla","logo":"./data/images/clubs/Puebla.png"},"positions":["MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ChristianMarrugo0.json
// module id = 796
// module chunks = 0